import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWedInWord from "../../../../src/content/wednesday-in-the-word/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWedInWord,
  React
};